import qs from 'qs'
import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useLocation, useNavigate } from 'react-router-dom'

import type { IAuthentication } from '~/types/authentication'

import { refreshToken } from '~/api/refresh-token'
import { COOKIES } from '~/const'
import { isTokenValid } from '~/utils/token'

const TokenHandler = (): null => {
  /** Local state */

  const navigate = useNavigate()

  const { search } = useLocation() // To allow App.tsx to re render

  const [cookies, setCookie, removeCookie] = useCookies([COOKIES.TOKENS])

  const accessTokens = qs.parse(search, { ignoreQueryPrefix: true })

  /** Effects */

  useEffect(() => {
    if (accessTokens?.access_token) {
      setCookie(COOKIES.TOKENS, accessTokens, { path: '/' })
      navigate(location.pathname)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function renewToken({ refresh_token: storedRefreshToken }: IAuthentication) {
      try {
        const newTokens = await refreshToken(storedRefreshToken)
        setCookie(COOKIES.TOKENS, newTokens, { path: '/' })
      } catch {
        removeCookie(COOKIES.TOKENS)
        navigate('/', { replace: true })
      }
    }

    const accessTokens: IAuthentication | undefined = cookies[COOKIES.TOKENS]

    if (accessTokens && !isTokenValid(accessTokens)) {
      renewToken(accessTokens)
    }
  }, [cookies, navigate, setCookie, removeCookie])

  return null
}

export default TokenHandler
